import React, { useState, useEffect } from 'react';

const TimeInput = ({ value = '', onChange, disabled }) => {
  const [internalValue, setInternalValue] = useState(value);
  const [isFocused, setIsFocused] = useState(false);
  
  useEffect(() => {
    setInternalValue(value);
  }, [value]);
  
  const handleChange = (e) => {
    let input = e.target.value.replace(/[^\d:]/g, '');
    
    if (input.length === 2 && !input.includes(':')) {
      input += ':';
    }
    
    if (input.length <= 5) {
      setInternalValue(input);
    }
  };
  
  const handleBlur = (e) => {
    setIsFocused(false);
    const timeValue = e.target.value;
    
    if (timeValue.includes(':')) {
      let [hours, minutes] = timeValue.split(':');
      
      hours = hours.padStart(2, '0');
      minutes = (minutes || '00').padStart(2, '0');
      
      const isValid = (
        (Number(hours) === 24 && Number(minutes) === 0) ||
        (Number(hours) >= 0 && Number(hours) < 24 && Number(minutes) >= 0 && Number(minutes) < 60)
      );
      
      if (isValid) {
        const formattedTime = `${hours}:${minutes}`;
        setInternalValue(formattedTime);
        onChange(formattedTime);
      } else {
        setInternalValue('');
        onChange('');
      }
    } else if (timeValue) {
      const numValue = parseInt(timeValue, 10);
      if (!isNaN(numValue) && numValue >= 0 && numValue < 24) {
        const formattedTime = `${numValue.toString().padStart(2, '0')}:00`;
        setInternalValue(formattedTime);
        onChange(formattedTime);
      } else {
        setInternalValue('');
        onChange('');
      }
    } else {
      setInternalValue('');
      onChange('');
    }
  };
  
  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.target.blur();
    }
  };
  
  return (
    <input
      type="text"
      inputMode="numeric"
      placeholder="HH:mm"
      value={internalValue}
      onChange={handleChange}
      onBlur={handleBlur}
      onFocus={handleFocus}
      onKeyDown={handleKeyDown}
      className={`
        w-full px-3 py-2 border rounded-md
        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
        disabled:bg-gray-100 disabled:cursor-not-allowed
        ${isFocused ? 'border-blue-500' : 'border-gray-300'}
      `}
      maxLength={5}
      disabled={disabled}
    />
  );
};

export default TimeInput;